export default "__VITE_ASSET__CVmiYPaX__"